import React from 'react';
import { Badge, ButtonSelect } from '@saviynt/design-system';

import './SmartFilterButtonSelect.css';

export function SmartFilterButtonSelect({
  isOpen,
  setIsOpen,
  label,
  showBadge,
  prefixIcon,
}) {
  return (
    <div className='SmartFilterButtonSelect-wrapper'>
      <ButtonSelect
        kind='pill'
        size='medium'
        className={`SmartFilterButtonSelect-button ${
          isOpen
            ? 'SmartFilterButtonSelect-button SmartFilterButtonSelect-button--IsOpen'
            : ''
        }`}
        isOpen={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        label={label}
        prefixIcon={prefixIcon}
        BadgeComp={
          showBadge ? <Badge kind='dot' color='primary' size='small' /> : null
        }
        isIconSvgFilled={false}
      />
    </div>
  );
}
